import React, { useState, ReactNode } from "react";
import { Drawer } from "antd";
import { FilterButton } from "@src/components/Common/FilterToolbar";

interface FiltersPopupWrapperProps {
    children: ReactNode;
    buttonText?: string;
    activeFiltersCount?: number;
}

/**
 * Filters for a page with no list to hang them on: the same compact button the
 * lists put on their column headers, opening the same side panel.
 *
 * One way to reach filters across the app — a button that looks the same, and a
 * panel that arrives from the same side however the page beneath it is built.
 */
const FiltersPopupWrapper: React.FC<FiltersPopupWrapperProps> = ({
    children,
    buttonText = "Filters",
    activeFiltersCount = 0,
}) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <FilterButton
                compact
                label={buttonText}
                count={activeFiltersCount}
                onClick={() => setOpen(true)}
            />
            <Drawer
                title={buttonText}
                classNames={{ body: 'ft-drawer__body' }}
                width={400}
                open={open}
                onClose={() => setOpen(false)}
            >
                {children}
            </Drawer>
        </>
    );
};

export default FiltersPopupWrapper;
